var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 0.900024C7.09047 0.900024 5.25912 1.65859 3.90886 3.00886C2.55859 4.35912 1.80002 6.19047 1.80002 8.10002V12.4032L0.951625 13.2516C0.783854 13.4194 0.669606 13.6332 0.623325 13.866C0.577044 14.0987 0.600808 14.34 0.691612 14.5592C0.782416 14.7784 0.936183 14.9658 1.13347 15.0977C1.33077 15.2296 1.56272 15.3 1.80002 15.3H16.2C16.4373 15.3 16.6693 15.2296 16.8666 15.0977C17.0639 14.9658 17.2176 14.7784 17.3084 14.5592C17.3992 14.34 17.423 14.0987 17.3767 13.866C17.3304 13.6332 17.2162 13.4194 17.0484 13.2516L16.2 12.4032V8.10002C16.2 6.19047 15.4415 4.35912 14.0912 3.00886C12.7409 1.65859 10.9096 0.900024 9.00002 0.900024ZM9.00002 20.1C8.04525 20.1 7.12957 19.7207 6.45444 19.0456C5.77931 18.3705 5.40002 17.4548 5.40002 16.5H12.6C12.6 17.4548 12.2207 18.3705 11.5456 19.0456C10.8705 19.7207 9.9548 20.1 9.00002 20.1Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.5644ac4a60a66f92869231feb899eb48.svg";
export { ForwardRef as ReactComponent };